/* eslint-disable */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const MailTemplateFilterPopup = ({
  tagList,
  setfilterDates,
  setfilterName,
  setfilterSubject,
  setfilterSlug,
  setfilterLabels,
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [name, setname] = useState("");
  const [subject, setsubject] = useState("");
  const [slug, setslug] = useState("");
  const [tags, setTags] = useState([]);
  // function for set tags
  const tagselectionHandler = (data) => {
    let prevTags = tags;
    if (prevTags.includes(data.value)) {
      let selectedTagItem = document.getElementById(
        "mailtemplatetagfilter-" + data.value
      );
      selectedTagItem.classList.remove("active");
      // exist in array, thus remove
      let key = prevTags.indexOf(data.value);
      prevTags.splice(key, 1);
    } else {
      let selectedTagItem = document.getElementById(
        "mailtemplatetagfilter-" + data.value
      );
      selectedTagItem.classList.add("active");
      // not exist in array, thus add
      prevTags.push(data.value);
    }
    setTags(prevTags);
  };
  //function for remove active class for selected tags
  const removeActiveClass = () => {
    const liElements = document.querySelectorAll(".tags li a");
    liElements.forEach((li) => {
      li.classList.remove("active");
    });
  };
  // reset selected skills
  const resetSelectTags = () => {
    let resetBlock = document.getElementsByClassName("tagblock");
    for (let i = 0; i < resetBlock.length; i++) {
      resetBlock[i].classList.remove("active");
    }
  };
  //function for search
  const searchHandler = () => {
    //check start date and end date are not empty.If end date empty then only search by start date
    if (fromDate != "" && toDate != "" && fromDate < toDate) {
      setfilterDates(fromDate + "," + toDate);
    } else if (fromDate != "") {
      setfilterDates(fromDate);
    }
    setfilterName(name);
    setfilterSubject(subject);
    setfilterSlug(slug);
    setfilterLabels(tags);
    // close the offcanvas of filter
    let offCanvasPopup = document.querySelector("#offcanvasFilter");
    let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
    offCanvas.hide();
    resetHandler();
  };
  //function for reset
  const resetHandler = () => {
    setFromDate("");
    setToDate("");
    setname("");
    setsubject("");
    setslug("");
    setTags([]);
    removeActiveClass();
    resetSelectTags();
  };
  return (
    <div
      className="offcanvas offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="offcanvasFilter"
      aria-labelledby="offcanvasFilterLabel"
    >
      <div className="offcanvas-header justify-content-end p-4 pb-0">
        <button
          type="button"
          className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <form onSubmit={(e) => e.preventDefault()}>
          {/* dates */}
          <div className="form-group mb-4">
            <label htmlFor="Name" className="d-block fs-sm fw-semibold mb-2">
              <h3>{t("Date")}</h3>{" "}
            </label>
            <div className="row gx-2">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <input
                  type="date"
                  className="form-control fs-sm shadow-none"
                  placeholder={t("From date")}
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="col-lg-6 mb-3 mb-lg-0">
                <input
                  type="date"
                  className="form-control fs-sm shadow-none"
                  placeholder={t("To date")}
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
            </div>
          </div>
          {/* name */}
          <div className="form-group mb-4">
            <label htmlFor="Name" className="d-block fs-sm fw-semibold mb-2">
              <h3>{t("Name")}</h3>{" "}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder={t("Name")}
              value={name}
              onChange={(e) => setname(e.target.value)}
            />
          </div>
          {/* subject */}
          <div className="form-group mb-4">
            <label htmlFor="Subject" className="d-block fs-sm fw-semibold mb-2">
              <h3>{t("Subject")}</h3>{" "}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder={t("Subject")}
              value={subject}
              onChange={(e) => setsubject(e.target.value)}
            />
          </div>
          {/* slug */}
          <div className="form-group mb-4">
            <label htmlFor="Slug" className="d-block fs-sm fw-semibold mb-2">
              <h3>{t("Slug")}</h3>{" "}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder={t("Slug")}
              value={slug}
              onChange={(e) => setslug(e.target.value)}
            />
          </div>
          <div className="accordion" id="accordionPanelsStayOpenExample">
            {/* ------ accordion for labels start ------ */}
            <div className="accordion-item bg-transparent border-0">
              <h3 className="accordion-header">
                <button
                  className="accordion-button bg-transparent p-0 shadow-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseThree"
                  aria-expanded="true"
                  aria-controls="panelsStayOpen-collapseThree"
                >
                  {t("Labels")}
                </button>
              </h3>
              <div
                id="panelsStayOpen-collapseThree"
                className="accordion-collapse collapse show"
              >
                <div className="accordion-body p-0 pt-4">
                  <ul className="tags d-flex flex-wrap gap-2 fs-sm fw-semibold">
                    {tagList.map((tag, index) => {
                      return (
                        <li className="tag" key={index}>
                          <Link
                            to="#"
                            onClick={() => tagselectionHandler(tag)}
                            id={"mailtemplatetagfilter-" + tag.value}
                            className="mailtagblock d-block px-3 py-2 gradient-light cursor-pointer rounded-90"
                          >
                            <span>{tag.label}</span>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            {/* ------ accordion for labels end ------ */}
          </div>
          <button
            type="button"
            className="btn btn-primary fs-sm fw-normal w-100 mt-4"
            onClick={searchHandler}
          >
            {t("Search")}
          </button>
        </form>
      </div>
    </div>
  );
};
export default MailTemplateFilterPopup;
